<form [formGroup]="form" class="flex flex-row space-x-[10px] items-start justify-start">
  <input id="copy" type="checkbox" formControlName="selected" class="accent-verde mt-[4px] w-[18px] h-[18px] shrink-0" />
  <button (click)="toggleSelect()" class="flex-1 text-base text-cafe font-normal text-start">{{checkBoxAndLabelInterface().label}}</button>
</form>
